import { LANGUAGES } from '../../../../content/languages';

export const PRIVACY_POLICY_LINKS: Record<LANGUAGES, string> = {
    [LANGUAGES.en]: 'https://www.specterx.com/privacy-policy',
    [LANGUAGES.he]: 'https://www.specterx.com/privacy-policy-heb/',
};

export const nameSpace = 'publicComponents.footer';
